import { render, staticRenderFns } from "./QuelpActionDialog.vue?vue&type=template&id=61079fa7&scoped=true"
import script from "./QuelpActionDialog.vue?vue&type=script&lang=js"
export * from "./QuelpActionDialog.vue?vue&type=script&lang=js"
import style0 from "./QuelpActionDialog.vue?vue&type=style&index=0&id=61079fa7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61079fa7",
  null
  
)

export default component.exports